import React, { MouseEvent, FC } from 'react'
import { Collapse } from 'react-collapse'
import {
  SContentContainer,
  SCrossIcon,
  SIconContainer,
  STabListItem,
  STitle,
  STitleContainer,
} from '@components/Questions/styled'
import { IQuestionsListItemProps } from '@components/Questions/types'

const QuestionsListItem: FC<IQuestionsListItemProps> = ({ title, content, isOpened, onOpen, onClose, index }) => {
  const onIconClick = (e: MouseEvent<HTMLElement>) => {
    e.stopPropagation()
    isOpened ? onClose() : onOpen(index)
  }

  const onTitleClick = () => {
    if (!isOpened) {
      onOpen(index)
    }
  }

  return (
    <STabListItem opened={+isOpened}>
      <STitleContainer onClick={onTitleClick}>
        <STitle>{title}</STitle>
        <SIconContainer opened={+isOpened} onClick={onIconClick}>
          <SCrossIcon opened={+isOpened} />
        </SIconContainer>
      </STitleContainer>
      <Collapse isOpened={isOpened}>
        <SContentContainer dangerouslySetInnerHTML={{ __html: content }} />
      </Collapse>
    </STabListItem>
  )
}

export default QuestionsListItem
